import { BASE_URL } from "config";
import { getHeaders } from "utils";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/domain/`,
    detail: (id) => `${BASE_URL}/api/v1/domain/${id}/`,
    makeMain: (id) => `${BASE_URL}/api/v1/domain/${id}/make_main/`,
};

export const domainLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const domainDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const domainUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const domainDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });
export const domainMakeMain = (token, data) => baseApi.Load(
    'put', endpoints.makeMain(data.id), data,
    {
        headers: getHeaders(token)
    }
);
